// needed by Wicket app. Function to close the dialog that this app is in
export const closeDialogIfInIframe = () => {
    if (window.parent.closeWindow) {
        window.parent.closeWindow("Job");
    }
};
